import React, { useState, useEffect } from 'react';
import { useParams, useNavigate } from 'react-router-dom';
import {
  Container,
  VStack,
  Heading,
  Text,
  Box,
  useColorModeValue,
  useToast,
  Spinner,
  Center,
} from '@chakra-ui/react';
import { useAuth } from '../contexts/AuthContext';
import BazarForm from '../components/Bazar/BazarForm';
import { fetchBazarById } from '../utils/bazarApi';

export default function BazarEdit() {
  const { id } = useParams();
  const navigate = useNavigate();
  const toast = useToast();
  const { isAuthenticated, userData } = useAuth();
  const [bazar, setBazar] = useState(null);
  const [loading, setLoading] = useState(true);

  // Redirect se non autenticato
  useEffect(() => {
    if (!isAuthenticated) {
      navigate('/bazar');
    }
  }, [isAuthenticated, navigate]);

  // Carica i dati del bazar
  useEffect(() => {
    const loadBazar = async () => {
      try {
        setLoading(true);
        const data = await fetchBazarById(id);
        setBazar(data);

        // Verifica che l'utente sia il proprietario
        // Gestisce diverse strutture possibili del socio
        const bazarData = data.attributes || data;
        let socio = null;

        if (bazarData.socio?.data) {
          socio = bazarData.socio.data;
        } else if (bazarData.socio) {
          socio = bazarData.socio;
        } else if (data.socio?.data) {
          socio = data.socio.data;
        } else if (data.socio) {
          socio = data.socio;
        }

        const socioEmail = socio?.email || socio?.attributes?.email;

        if (!userData || !socioEmail || userData.email !== socioEmail) {
          toast({
            title: 'Accesso negato',
            description: 'Non sei autorizzato a modificare questo oggetto',
            status: 'error',
            duration: 3000,
          });
          navigate(`/bazar/${id}`);
        }
      } catch (error) {
        toast({
          title: 'Errore',
          description: error.message || "Impossibile caricare l'oggetto",
          status: 'error',
          duration: 3000,
        });
        navigate('/bazar');
      } finally {
        setLoading(false);
      }
    };

    if (isAuthenticated && id) {
      loadBazar();
    }
  }, [id, isAuthenticated, userData, navigate, toast]);

  if (!isAuthenticated || loading) {
    return (
      <Container maxW="container.md" py={8}>
        <Center py={12}>
          <Spinner size="xl" color="brand.100" />
        </Center>
      </Container>
    );
  }

  if (!bazar) {
    return null;
  }

  const handleSuccess = () => {
    navigate(`/bazar/${id}`);
  };

  return (
    <Container maxW="container.md" py={8}>
      <VStack spacing={6} align="stretch">
        <Box>
          <Heading size="lg" mb={2}>
            Modifica oggetto
          </Heading>
          <Text color={useColorModeValue('gray.600', 'gray.400')}>
            Modifica i dettagli del tuo oggetto nel Bazar
          </Text>
        </Box>

        <BazarForm bazar={bazar} onSuccess={handleSuccess} />
      </VStack>
    </Container>
  );
}
